import { ActionTypes } from "../contants/action-type";

const initialState = {
    allorders: [],
    acceptedorders: [],
    preparedorders: [],
    deliveredorders: [],
    rejectedorders: [],
    order: {}
}

export const OrderReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.LIST_ALL_ORDER:
            return {...state, allorders: payload};
        case ActionTypes.LIST_ACCEPTED_ORDER:
            return {...state, acceptedorders: payload};
        case ActionTypes.LIST_PREPARED_ORDER:
            return {...state, preparedorders: payload};
        case ActionTypes.LIST_DELIVERED_ORDER:
            return {...state, deliveredorders: payload};
        case ActionTypes.LIST_REJECTED_ORDER:
            return { ...state, rejectedorders: payload };
        case ActionTypes.SELECTED_ORDER:
            return { ...state, order: payload };
        default:
            return state;
    }
}